import PostType from '@research-api/utils/api/typings/PostType';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import FrontPageLayout from '@/components/pages/frontpage/layout/FrontPageLayout';
import type { GlobalOptionProps, IComponent } from '@/types/_app';
import type { ArticleType, Webinar } from '@/types/ArticleType';
import type { Category } from '@/utils/functions/wordpress/fetchCategories';
import type Podcast from '@/types/pages/api/podcasts/Podcast';

export interface FrontPageControllerProps {
    readMoreArticles: ArticleType[];
    featuredPosts: ArticleType[];
    researchArticles: PostType[];
    categories: Category[];
    podcasts: Podcast[];
    upcomingWebinars: Webinar[];
    options: GlobalOptionProps;
}

export const FrontPageController: IComponent<any> = ({
    readMoreArticles,
    featuredPosts,
    researchArticles,
    categories,
    podcasts,
    upcomingWebinars,
    options,
}: FrontPageControllerProps) => {
    return (
        <FrontPageLayout
            researchPosts={researchArticles}
            featuredPosts={featuredPosts}
            articles={readMoreArticles}
            categories={categories || []}
            podcasts={podcasts}
            upcomingWebinars={upcomingWebinars}
            options={options}
        />
    );
};

export default withExceptionCatcher(FrontPageController);
